import QualityEntityForm from '../components/layouts/QualityEntityForm'

import useQaDocumentStatuses from '../hooks/useQaDocumentStatuses'
import useQualityContents from '../hooks/useQualityContents'
import { ENTITY_TYPES } from '../hooks/useQualityEntity';

const QaDocument = () => {
    const {
        qaDocumentStatuses,
        qaDocumentAreas,
        qaDocumentTypes,
    } = useQaDocumentStatuses()

    const {
        updateQaDocument,
        deleteQaDocument,
        forceReloadQaDocuments,
    } = useQualityContents()

    return (
        <QualityEntityForm
            entityType={ENTITY_TYPES.QA_DOCUMENT}
            areaOptions={qaDocumentAreas}
            typeOptions={qaDocumentTypes}
            statusOptions={qaDocumentStatuses}
            hasClassification

            // Callback functions
            onUpdateDocument={updateQaDocument}
            onForceReloadDocuments={forceReloadQaDocuments}
            onDelete={deleteQaDocument}
        />
    )
};

export default QaDocument
